<!-- app页面——分享资料 -->
<template>
  <div class="shareInfoH5">
    <van-nav-bar title="分享资料" left-arrow @click-left="toBack" @click-right="addShow = true">
      <template v-if="SHARINFORMATION_ADD" #right>
        <van-icon name="plus" size="18" color="#007AF5" />
      </template>
    </van-nav-bar>
    <div class="content">
      <!-- 面包屑 -->
      <ul class="breadcrumb">
        <li v-for="(item, index) in navList" :key="index" :class="{ navActive: item.folderId === currentFolderId }" @click="clickBread(item, index)">
          {{ item.folderName }}
          <span v-if="index !== navList.length - 1" style="padding: 0px 6px">/</span>
        </li>
      </ul>
      <!-- 文档列表 -->
      <van-pull-refresh v-model="refreshing" v-loading="loading" class="folderList" @refresh="onRefresh">
        <div v-for="item in shareInfoList" :key="item.folderId" class="folderItem" @click="nextDetails(item)">
          <oneFileFolder :key="item.folderId" :item="item" @moreOpen="moreOpen(item)"></oneFileFolder>
        </div>
        <div v-if="!shareInfoList.length" class="empty">暂无数据</div>
      </van-pull-refresh>
    </div>

    <!-- 添加文件夹和文件按钮 -->
    <van-popup v-model="addShow" round class="addPopup" @close="addShow = false">
      <div class="addBtns">
        <van-button type="info" style="margin-bottom: 10px" @click="addFolderOpen">添加文件夹</van-button>
        <van-button @click="uploadFileOpen">上传文件</van-button>
      </div>
    </van-popup>
    <!-- 添加文件夹弹框 -->
    <van-popup v-model="addFolderShow" round @close="addFolderClose">
      <div class="addFolderStyle">
        <div class="text">添加文件夹</div>
        <van-field v-model="addFolderName" placeholder="请输入" clearable class="addFolderName" />
        <div class="buttonSlider">
          <van-button text="取消" type="info" round plain @click="addFolderClose" />
          <van-button text="确认" type="info" round @click="addFolderSure" />
        </div>
      </div>
    </van-popup>
    <!-- 更多弹框 -->
    <shareInfoMore ref="shareInfoMore" :currentFolderId="currentFolderId" @toRefresh="toRefresh"></shareInfoMore>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Notify } from "vant";
import { viewAppFileMethods } from "@/CommonDP/pages/appView/utils";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import { throttle } from "@/CommonDP/utils/throttle.js"; // 函数节流
import docService from "@/CommonDP/service/doc-service";
import oneFileFolder from "../../components/oneFileFolder.vue";
import shareInfoMore from "./shareInfoMore.vue";

export default {
  components: { oneFileFolder, shareInfoMore },
  data() {
    return {
      SHARINFORMATION_ADD: checkPermission(this.$allPerms.SHARINFORMATION_ADD), // 添加权限
      navList: [], // 展开路径
      currentFolderId: "", // 当前打开的文件夹id
      // 请求参数
      argument: {
        folderId: "0",
        isPersonal: 1,
        isRead: 1,
        priviAll: "1",
        type: "",
        noRightClickMenu: true,
        versionId: ""
      },
      shareInfoList: [], // 分享资料列表
      addShow: false, // 添加弹框
      addFolderShow: false, // 添加文件夹弹框
      addFolderName: "", // 添加文件夹名称
      refreshing: false,
      loading: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted() {
    this.getShareInfoList_init();
  },
  methods: {
    // 返回上一页
    toBack() {
      this.$router.go(-1);
    },
    // 获得分享资料列表_初始化
    async getShareInfoList_init() {
      const enterpriseId = this.enterpriseId;
      const params = { ...this.argument, enterpriseId };
      const res = await docService.queryenterpriseTree(params);
      // 设置展开路径
      const { folderId } = res.data[0] || {};
      this.currentFolderId = folderId || "";
      const nav = { folderId, folderName: "分享资料" };
      this.navList.push(nav);
      this.getShareInfoList(folderId);
    },
    // 获得分享资料列表
    async getShareInfoList(folderId) {
      this.loading = true;
      try {
        const enterpriseId = this.enterpriseId;
        const params = { ...this.argument, enterpriseId, folderId };
        const res = await docService.queryenterpriseTree(params);
        this.shareInfoList = res.data || [];
        this.currentFolderId = folderId;
      } finally {
        this.loading = false;
      }
    },

    // 刷新列表
    toRefresh() {
      this.getShareInfoList(this.currentFolderId);
    },
    // 点击路径
    clickBread(item, index) {
      this.navList = this.navList.slice(0, index + 1);
      this.getShareInfoList(item.folderId);
    },
    // 下拉刷新
    async onRefresh() {
      try {
        const folderId = this.currentFolderId;
        await this.getShareInfoList(folderId);
      } finally {
        this.refreshing = false;
      }
    },
    // 点击文件夹，进入下一级
    nextDetails: throttle(function (item) {
      if (item.isFolder === 1) {
        this.navList.push(item);
        this.getShareInfoList(item.folderId);
      } else {
        // 预览文件
        if (item.isDelete === 1) {
          return Notify({ type: "warning", message: "该文件已删除，无法查看" });
        }
        const value = {
          fileId: item.folderId,
          versionId: item.fileVersion,
          fileType: item.fileType,
          noNeedIssue: "true"
        };
        viewAppFileMethods(item, value);
      }
    }),

    // 点击... 打开更多
    moreOpen(item) {
      if (item.isFolder === 1) this.$refs.shareInfoMore.setFolderPrivi(item);
      else this.$refs.shareInfoMore.setFilePrivi(item);
    },
    // 添加文件夹打开
    addFolderOpen() {
      this.addFolderShow = true;
      this.addShow = false;
    },
    // 添加文件夹关闭
    addFolderClose() {
      this.addFolderShow = false;
      this.addFolderName = "";
    },
    // 添加文件夹确定
    async addFolderSure() {
      const folderName = this.addFolderName.replace(/\s*/g, "");
      if (!folderName) {
        return Notify({ type: "warning", message: "名称不能为空且不超过80个字符" });
      }
      if (folderName.length > 80) {
        return Notify({ type: "warning", message: "名称不能超过80个字符" });
      }
      const regExp = new RegExp('[\\\\|/:*<>?"]');
      if (regExp.test(folderName)) {
        return Notify({ type: "warning", message: '文件夹名称不能包含以下字符:\\ / : * " ? < > |' });
      }
      const params = {
        enterpriseId: this.enterpriseId,
        parentId: this.currentFolderId,
        folderName
      };
      await docService.queryenterpriseAddFolder(params);
      Notify({ type: "success", message: "新建成功!" });
      this.addFolderClose();
      this.toRefresh();
    },

    // 上传文件
    uploadFileOpen() {
      Notify({ type: "warning", message: "暂不支持该功能" });
    }
  }
};
</script>

<style lang="scss" scoped>
.shareInfoH5 {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #f5f6fa;

  .content {
    width: 100%;
    height: calc(100% - 56px);
    margin-top: 10px;
  }
}

.breadcrumb {
  width: 100%;
  height: 32px;
  line-height: 32px;
  padding: 0 16px;
  white-space: nowrap;
  background-color: #ffffff;
  border-bottom: 1px solid #e5e8f1;
  overflow: auto;

  li {
    list-style: none;
    display: inline-block;
    color: #006dfe;
    font-size: 14px;
  }

  .navActive {
    color: var(--key-color);
  }
}

.folderList {
  width: 100%;
  height: calc(100% - 40px);
  overflow-y: auto;
  .empty {
    width: 100%;
    height: calc(100% - 66px);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--info-color)9;
    font-size: 16px;
  }
}

::v-deep .addPopup {
  .addBtns {
    width: 180px;
    padding: 20px 3vw;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.addFolderStyle {
  width: 90vw;
  padding: 0 4vw;

  .text {
    padding: 3vh 5vw;
    font-size: 16px;
    white-space: pre-wrap;
    text-align: center;
  }

  .addFolderName {
    border: 1px solid #e5e8f1 !important;
    background: #f5f5f5;
  }

  .buttonSlider {
    width: 100%;
    padding: 3vh 0;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .van-button {
      width: 40%;
    }
  }
}

::-webkit-scrollbar {
  display: none;
}
</style>
